var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.$numbers(_vm.value).format({ output: 'percent', mantissa: 1, thousandSeparated: true})))])
}
var staticRenderFns = []

export { render, staticRenderFns }